var _effectorFileName = "/src/shared/components/line-with-circles/line-with-circles.tsx";
import React, { useRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { RevealAnimation } from '../animation/reveal';
interface LineWithCirclesProps {
  children: React.ReactNode;
  className?: string;
}
export const LineWithCircles = (props: LineWithCirclesProps) => {
  const {
    children,
    className
  } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);
  return <div className={cn('relative ml-10 max-w-3xl sm:ml-12', className)}>
      <div ref={wrapperRef} className="space-y-6">
        {React.Children.map(children, (child, index) => <RevealAnimation key={index} delay={0.2}>
            <>
              <div className="absolute -left-[26px] -top-2 h-[calc(100%+20px)] w-1 bg-brand-accent-light sm:-top-4 sm:h-[calc(100%+30px)]"></div>

              <div className="relative">
                {child}
                <div className="absolute -left-[34px] top-3 z-10 h-5 w-5 -translate-y-1/2 transform rounded-full border-2 border-brand-accent-dark bg-brand-accent-superLight outline outline-white"></div>
              </div>
            </>
          </RevealAnimation>)}
      </div>
    </div>;
};